import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlideshowModule } from 'ng-simple-slideshow';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { TooltipModule } from 'ng2-tooltip-directive';
import { PipesModule } from '../pipes/pipes.module';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { ImageCropperModule } from 'ng2-img-cropper';
import { ModalModule } from './modal/modal.module';
import { ModalModule as NgxModalModule } from 'ngx-bootstrap';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { SelectModule } from 'ng2-select';
import { CampaignComponent } from './campaign/campaign.component';
import { ChatBotComponent } from './chat-bot/chat-bot.component';
import { CarouselPromotionComponent } from './carousel-promotion/carousel-promotion.component';
import { EstablishmentCardComponent } from './establishment-card/establishment-card.component';
import { CinemaTicketComponent } from './cinema-ticket/cinema-ticket.component';
import { EstablishmentsMapComponent } from './establishments-map/establishments-map.component';
import { HeaderMenuComponent } from './header-menu/header-menu.component';
import { InviteComponent } from './invite/invite.component';
import { ModalCouponComponent } from './modal-coupon/modal-coupon.component';
import { ListingSearchComponent } from './listing-search/listing-search.component';
import { MapboxSearchComponent } from './mapbox-search/mapbox-search.component';
import { CropperComponent } from '../directives/cropper/cropper.component';
import { FiltersComponent } from './nav-filters/nav-filters';
import { OverlayLoadingComponent } from './overlay-loading/overlay-loading.component';
import { ReportsComponent } from './reports/reports.component';
import { SearchContainerComponent } from './search-container/search-container.component';
import { SearchFiltersComponent } from './search-filters/search-filters.component';
import { SearchNoResultsComponent } from './search-no-results/search-no-results.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { CashbackPartnersComponent } from './cashback-partners/cashback-partners.component';
import { SimulatorComponent } from './simulator/simulator.component';
import { OwnPartnershipFormComponent } from './own-partnership-form/own-partnership-form.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { MomentModule } from 'angular2-moment';
import { CostCenterFormComponent } from './cost-center-form/cost-center-form.component';
import { ReportCardComponent } from './report-card/report-card.component';
import { InfoTooltipComponent } from './info-tooltip/info-tooltip.component';
import { GroupSelectComponent } from './group-select/group-select.component';
import { SearchEstablishmentModalComponent } from './search-establishment-modal/search-establishment-modal.component';
import { AcceptanceTermsComponent } from './acceptance-terms/acceptance-terms.component';
import { AcceptanceTermsModalComponent } from './acceptance-terms-modal/acceptance-terms-modal.component';
import { PlatformAccessBlockedModalComponent }
  from './platform-access-blocked-modal/platform-access-blocked-modal.component';
import { InvitationBannerComponent } from './invitation-banner/invitation-banner.component';
import { InvitationLinkComponent } from './invitation-link/invitation-link.component';
import { CopyClipboardDirective } from '../directives/copy-clipboard.directive';
import { InvitationVouchersComponent } from './invitation-vouchers/invitation-vouchers.component';
import { InvitationAcceptedComponent } from './invitation-accepted/invitation-accepted.component';
import { InvitesListComponent } from './invites-list/invites-list.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { VouchersListComponent } from './vouchers-list/vouchers-list.component';
import { VoucherCardComponent } from './voucher-card/voucher-card.component';
import { VoucherDetailsModalComponent } from './voucher-details-modal/voucher-details-modal.component';
import { VoucherAlertModalComponent } from './voucher-alert-modal/voucher-alert-modal.component';
import { TrialToasterComponent } from './trial-toaster/trial-toaster.component';
import { EstablishmentRedirection } from './establishment-redirection/establishment-redirection.component';
import { LoadingComponent } from './loading/loading.component';
import { BulkBlockComponent } from './bulk-block/bulk-block.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { ContainerComponent } from './tickets/container/container.component';
import { PaymentResumeComponent } from './tickets/payment-resume/payment-resume.component';
import { ProductListComponent } from './tickets/product-list/product-list.component';
import { CardsListComponent } from './tickets/cards-list/cards-list.component';
import { SendDataComponent } from './tickets/send-data/send-data.component';
import { SuccessComponent } from './tickets/success/success.component';
import { ErrorComponent } from './tickets/error/error.component';
import { AddCardComponent } from './tickets/add-card/add-card.component';
import { AddressListComponent } from './tickets/address-list/address-list.component';
import { AddAddressComponent } from './tickets/add-address/add-address.component';
import { ConfirmCVVComponent } from './tickets/confirm-cvv/confirm-cvv.component';
import { CardItemComponent } from './tickets/card-item/card-item.component';
import { CardSelectionComponent } from './tickets/card-selection/card-selection.component';
import { CardConfirmComponent } from './tickets/card-confirm/card-confirm.component';
import { TicketsModalComponent } from './tickets/modal/modal.component';
import { ModalCoreComponent } from './modal-core/modal.component';
import { PromoDetailsComponent } from './promo-details/promo-details.component';
import { PromoEstablishmentComponent } from './promo-establishment/promo-establishment.component';
import { PremiumModalComponent } from './premium-modal/premium-modal.component';
import { PortalExternalRedirectComponent } from './portal-external-redirect/portal-external-redirect.component';
import { NoveNoveCheckoutComponent } from './nove-nove-checkout/nove-nove-checkout.component';
import {BsModalService, CarouselModule} from 'ngx-bootstrap';

export const COMPONENTS = [
  CampaignComponent,
  CarouselPromotionComponent,
  ChatBotComponent,
  CinemaTicketComponent,
  CropperComponent,
  EstablishmentCardComponent,
  EstablishmentsMapComponent,
  FiltersComponent,
  HeaderMenuComponent,
  InviteComponent,
  ModalCouponComponent,
  ListingSearchComponent,
  MapboxSearchComponent,
  OverlayLoadingComponent,
  OwnPartnershipFormComponent,
  ReportsComponent,
  SearchContainerComponent,
  SearchFiltersComponent,
  SearchNoResultsComponent,
  SearchResultsComponent,
  CashbackPartnersComponent,
  CostCenterFormComponent,
  SimulatorComponent,
  ReportCardComponent,
  InfoTooltipComponent,
  GroupSelectComponent,
  SearchEstablishmentModalComponent,
  AcceptanceTermsComponent,
  AcceptanceTermsModalComponent,
  PlatformAccessBlockedModalComponent,
  InvitationBannerComponent,
  CopyClipboardDirective,
  InvitationLinkComponent,
  InvitationVouchersComponent,
  InvitationAcceptedComponent,
  InvitesListComponent,
  BreadcrumbComponent,
  VouchersListComponent,
  VoucherCardComponent,
  VoucherDetailsModalComponent,
  VoucherAlertModalComponent,
  TrialToasterComponent,
  EstablishmentRedirection,
  LoadingComponent,
  BulkBlockComponent,
  FileUploadComponent,
  ContainerComponent,
  PaymentResumeComponent,
  ProductListComponent,
  CardsListComponent,
  SendDataComponent,
  SuccessComponent,
  ErrorComponent,
  AddCardComponent,
  AddressListComponent,
  AddAddressComponent,
  ConfirmCVVComponent,
  CardItemComponent,
  CardSelectionComponent,
  CardConfirmComponent,
  TicketsModalComponent,
  ModalCoreComponent,
  PromoDetailsComponent,
  PromoEstablishmentComponent,
  PremiumModalComponent,
  PortalExternalRedirectComponent,
  NoveNoveCheckoutComponent
];

@NgModule({
  imports: [
    CommonModule,
    CKEditorModule,
    FormsModule,
    GooglePlaceModule,
    ImageCropperModule,
    InfiniteScrollModule,
    LeafletModule,
    ModalModule,
    MomentModule,
    MultiselectDropdownModule,
    NgbModule,
    PipesModule,
    ReactiveFormsModule,
    RouterModule,
    SelectModule,
    SlideshowModule,
    TextMaskModule,
    TooltipModule,
    TranslateModule,
    CarouselModule,
    NgxModalModule
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
  providers: [BsModalService]
})
export class ComponentsModule {}
